import { render, staticRenderFns } from "./BillingChange.vue?vue&type=template&id=c4ba6a7c"
import script from "./BillingChange.vue?vue&type=script&lang=js"
export * from "./BillingChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports